"use client";

import { Download } from "lucide-react";
import { useAuthModal } from "@/features/auth/auth-modal";

/**
 * Nút "Đăng nhập để tải" cho trang chi tiết công khai — mở modal đăng nhập/đăng ký
 * ngay tại trang (không rời trang). Sau khi đăng nhập, trang refresh → mở khoá nút tải.
 */
export function GuestDownloadButton({ className, label }: { className: string; label: string }) {
  const { openAuth } = useAuthModal();
  return (
    <button type="button" onClick={() => openAuth("register")} className={className}>
      <Download className="size-5" aria-hidden="true" />
      {label}
    </button>
  );
}
